'use client'
import ProductCard from '@components/atoms/ProductCard'
import ProductCardSkeleton from '@components/atoms/ProductCardSkeleton'
import { userContext } from '@components/context/userContext'
import { Button } from '@components/ui/button'
import { useRouter } from 'next/navigation'
import React, { useContext } from 'react'

export interface WishListPageProps extends React.HTMLAttributes<HTMLElement> {
  // occasions: OccasionProps[]
  // products: Product[]
  // isLoading: boolean
  // occasion: OccasionProps
}

const WishList = () => {
  const { wishlist } = useContext(userContext);
  const router = useRouter()

  if (wishlist.length === 0) return (
    <div className=" w-full  rounded-sm text-center text-gray-700 flex flex-col gap-4 justify-center items-center p-4 py-16">
                <div className="headline_large ">YOUR WISHLIST IS EMPTY</div>
                <div className=" text-gray-400">
                  <div className=" title_large">There is nothing in your wishlist.</div>
                  <div className=" title_large">Let's add some items</div>
                </div>
                <div>
                  <Button
                    className=" text-primary-500 border-primary-500"
                    onClick={() => {
                      router.push('/products')
                    }}
                    variant={'outline'}
                  >
                    Start shopping
                  </Button>
                </div>
              </div>
  )

  if (wishlist.length === 0) return (
    <div className=" w-full  rounded-sm text-center text-gray-700 flex flex-col gap-4 justify-center items-center p-4 py-16">
                <div className="headline_large ">YOUR WISHLIST IS EMPTY</div>
                <div className=" text-gray-400">
                  <div className=" title_large">There is nothing in your wishlist.</div>
                  <div className=" title_large">Let's add some items</div>
                </div>
                <div>
                  <Button
                    className=" text-primary-500 border-primary-500"
                    onClick={() => {
                      router.push('/products')
                    }}
                    variant={'outline'}
                  >
                    Start shopping
                  </Button>
                </div>
              </div>
  )

  return (
    <>
      <div className=" m-2 md:my-5 flex g-10 items-center">
        <div className="headline_large">My Wishlist</div>
        {wishlist ? <div className="title_large ml-5">{wishlist.length} items</div> : null}
      </div>
      <div className=" w-full grid grid-cols-2 p-2 md:grid-cols-4 md:grid-rows-2 gap-3">
        {!wishlist
          ? Array.from({ length: 4 }, (_, index) => (
            <ProductCardSkeleton key={index} />
          ))
          : wishlist.map((wish, index) => (
            <ProductCard
              isLoading={!wishlist}
              product={wish.product}
              key={wish.productId} // Ideally, use a unique ID from the product instead of index
              category={wish.product.categoryId[0].id}
              occasion={wish.product.ocassionId[0].id}
            />
          ))}
      </div>
    </>
  )

  return <div className=" h-8 w-full bg-red-400">{wishlist[3].product.imageIds}</div>
}

export default WishList
